import { z } from "zod/mini"

const DateConfigSchema = z.object({
	label: z.nullish(z.string()),
	placeholder: z.optional(z.string()),
	default: z.optional(z.string()),
})

export const DateModelSchema = z.object({
	type: z.literal("Date"),
	fieldset: z.nullish(z.string()),
	config: z.optional(DateConfigSchema),
})

export type DateModel = z.infer<typeof DateModelSchema>
